// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2aVrb","content":"styles_content__3zs88","selectAll":"styles_selectAll__3zpjG"};